<template>
  <main>
    <div class="bg-gray-200 py-2">
      <div class="breadcrumbs container mx-auto">
        <nuxt-link :to="localePath('index')" class="breadcrumb  px-2">
          {{ $t('home') }}</nuxt-link
        >
        <nuxt-link :to="localePath('global-presence')" class="breadcrumb  px-2">
          {{ $t('GLOBAL_PRESENCE') }}</nuxt-link
        >
      </div>
    </div>
    <div class="header text-center py-32">
      <h1 class="text-3xl text-white font-bold">{{ $t('GLOBAL_PRESENCE') }}</h1>
      <p class="text-white">{{ $t('global_presence_info') }}</p>
    </div>
    <div class="px-4 container mx-auto mt-12">
      <div v-scroll-reveal class="card items-center flex-col md:flex-row">
        <img
          class=""
          src="/img/shipping_from_europe.jpg"
          alt="shipping_from_europe image"
        />
        <div>
          <h3 class="text-3xl text-black font-bold mt-0 mb-4">
            {{ $t('shipping_from_europe') }}
          </h3>
          <p class="text-gray-900 text-light mb-12">
            {{ $t('shipping_from_europe_text') }}
          </p>
          <a
            href="#"
            class="hidden bg-blue-600 hover:bg-blue-700 px-12 uppercase hover:text-white mt-6 text-white px-5 py-3"
          >
            {{ $t('learn_more') }}
          </a>
        </div>
      </div>
      <div v-scroll-reveal class="card items-center flex-col md:flex-row">
        <img
          class=""
          src="/img/shipping_from_asia.jpg"
          alt="shipping_from_asia image"
        />
        <div>
          <h3 class="text-3xl text-black font-bold mt-0 mb-4">
            {{ $t('shipping_from_asia') }}
          </h3>
          <p class="text-gray-900 text-light mb-12">
            {{ $t('shipping_from_asia_text') }}
          </p>
          <a
            href="#"
            class="hidden bg-blue-600 hover:bg-blue-700 px-12 uppercase hover:text-white mt-6 text-white px-5 py-3"
          >
            {{ $t('learn_more') }}
          </a>
        </div>
      </div>
      <div v-scroll-reveal class="card items-center flex-col md:flex-row ">
        <img
          class=""
          src="/img/shipping_from_america.jpg"
          alt="shipping_from_america image"
        />
        <div>
          <h3 class="text-3xl text-black font-bold mt-0 mb-4">
            {{ $t('shipping_from_america') }}
          </h3>
          <p class="text-gray-900 text-light mb-12">
            {{ $t('shipping_from_america_text') }}
          </p>
          <a
            href="#"
            class="hidden bg-blue-600 hover:bg-blue-700 px-12 uppercase hover:text-white mt-6 text-white px-5 py-3"
          >
            {{ $t('learn_more') }}
          </a>
        </div>
      </div>
    </div>

    <div class="text-center my-6 pb-4">
      <h4 class="font-bold text-2xl ">{{ $t('anything_you_need_help') }}</h4>
      <div class="flex flex-wrap justify-center">
        <nuxt-link
          :to="localePath('solutions')"
          class="button w-56 bg-red-600 hover:bg-red-700 px-12 uppercase hover:text-white mt-6 sm:mr-3 text-white px-5 py-3"
          >{{ $t('OUR_SOLUTIONS') }}</nuxt-link
        >
        <nuxt-link
          :to="localePath('contact')"
          class="button w-56 bg-transparent text-black uppercase border-2 border-black px-5 py-3 mt-6 hover:bg-black hover:text-white"
          >{{ $t('contact') }}</nuxt-link
        >
      </div>
    </div>
  </main>
</template>

<script>
export default {}
</script>

<style scoped>
.submenu-icon {
  @apply mb-3;
}
.header {
  background: linear-gradient(to right, rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0)),
    url('/img/about_header_background.jpg');
  background-position: center;
  background-size: cover;
  position: relative;
}
.header:after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  left: 0;
  bottom: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05), transparent);
  z-index: -1;
}
.about-content {
  transform: translateY(-75px);
  z-index: 999;
}
.card {
  display: flex;
  margin-bottom: 35px;
  min-height: 300px;
  /* max-height: 350px; */
}
.card img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}

@screen md {
  .card:nth-child(odd) {
    flex-direction: row-reverse;
  }

  .card:nth-child(even) div {
    padding-left: 25px;
    padding-right: 0;
  }
  .card img {
    width: 50%;
    height: auto;
    object-fit: cover;
    max-height: 350px;
  }
  .card div {
    padding-right: 25px;
    width: 50%;
  }
}
</style>
